const OrganisationTypes = {
	CREATE_ORGANISATION_START: 'create_organisation_start',
	CREATE_ORGANISATION_SUCCESS: 'create_organisation_success',
	CREATE_ORGANISATION_FAILURE: 'create_organisation_failure',
	UPDATE_ORGANISATION_START: 'update_organisation_start',
	UPDATE_ORGANISATION_SUCCESS: 'update_organisation_success',
	UPDATE_ORGANISATION_FAILURE: 'update_organisation_failure',
	GET_ORGANISATION_START: 'get_organisation_start',
	GET_ORGANISATION_SUCCESS: 'get_organisation_success',
	GET_ORGANISATION_FAILURE: 'get_organisation_failure',
	GET_ALL_ORGANISATIONS_START: 'get_all_organisations_start',
	GET_ALL_ORGANISATIONS_SUCCESS: 'get_all_organisations_success',
	GET_ALL_ORGANISATIONS_FAILURE: 'get_all_organisations_failure',
	UPDATE_ORGANISATION_STATUS_START: 'update_organisation_status_start',
	UPDATE_ORGANISATION_STATUS_SUCCESS: 'update_organisation_status_success',
	UPDATE_ORGANISATION_STATUS_FAILURE: 'update_organisation_status_failure',
	ORGANISATION_RESPONSE_CHANGED: 'organisation_response_changed',
	ORGANISATION_RESPONSE_REST_START: 'organisation_response_rest_start',
} as const;

export default OrganisationTypes;
